import axios from 'axios';

import { axiosHeaderV2, getV2RootUrl } from 'common/helpers/apiHelper';

export const listProductRatings = (customerId) =>
  axios.get(
    `${getV2RootUrl()}/customer/${customerId}/favorite`,
    axiosHeaderV2()
  );

export const addProductRatingLike = (customerId, productId) =>
  axios.post(
    `${getV2RootUrl()}/customer/${customerId}/favorite/${productId}/like`,
    {},
    axiosHeaderV2()
  );

export const addProductRatingDislike = (customerId, productId) =>
  axios.post(
    `${getV2RootUrl()}/customer/${customerId}/favorite/${productId}/dislike`,
    {},
    axiosHeaderV2()
  );

export const deleteProductRating = (customerId, productId) =>
  axios.delete(
    `${getV2RootUrl()}/customer/${customerId}/favorite/${productId}`,
    axiosHeaderV2()
  );
